import { css } from 'styled-components';

export const ViewPresetHeaderStyles = css`
  .b-sch-header-timeaxis-cell.current-day .b-sch-header-text {
    background: var(--orange-40);
    color: var(--white-100);
    border-radius: 40px;
    padding: 0 var(--spacing-03);
  }

  .b-schedulerpro[data-preset-id|='month'] {
    .b-sch-header-row {
      &.b-sch-header-row-1 .b-sch-header-timeaxis-cell {
        border-bottom: none;
        background: var(--white-100);
      }
      &.b-sch-header-row-2,
      &.b-sch-header-row-3 {
        flex: 0;
      }
    }
  }
  .b-schedulerpro[data-preset-id|='week'] {
    .b-sch-header-row {
      &.b-sch-header-row-2 .b-sch-header-timeaxis-cell {
        border-bottom: none;
        background: var(--white-100);
        font-size: var(--font-size-sm);
      }
      &.b-sch-header-row-0,
      &.b-sch-header-row-3 {
        flex: 0;
        .b-sch-header-timeaxis-cell {
          border-bottom: none;
        }
      }
    }
  }
  .b-schedulerpro[data-preset-id|='day'] {
    .b-sch-header-row.b-sch-header-row-1 .b-sch-header-timeaxis-cell {
      background: var(--white-100);
    }
  }
`;
